/**
 * The nine categories and four modes, for the two screens.
 *
 * FLAGGED DUPLICATION, and it is the same one `apps/api/src/notifications/copy.ts`
 * carries. `apps/web/package.json` depends on `@oprappo/contracts`, `@oprappo/tokens`
 * and `@oprappo/ui`; the API's notification package is not a dependency of the web app
 * and cannot become one — `apps/api/src/notifications/**` is server code, and
 * `apps/web/package.json` belongs to another package during this wave (docs/10 § rule 1).
 *
 * The right home for these is `@oprappo/contracts`, which is exactly "shared types
 * between the Worker API and the web client". WP-M does not own that package and it is
 * append-only during this wave, so the two lists are duplicated and reported rather than
 * moved. Both are transcribed from `supabase/migrations/0013_notifications.sql § 1`, in
 * the migration's order, so they compare equal to the API's copy value for value.
 */

export const NOTIF_CATEGORIES = [
  'action_required',
  'critical',
  'business_update',
  'customer',
  'team',
  'ai',
  'financial',
  'compliance',
  'system',
] as const;
export type NotifCategory = (typeof NOTIF_CATEGORIES)[number];

export const NOTIF_MODES = ['immediate', 'daily_digest', 'weekly', 'silent'] as const;
export type NotifMode = (typeof NOTIF_MODES)[number];
